var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var ImageOverlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return "\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: ".concat(theme.black(isActive ? 0 : 0.6), ";\n");
});
export var Overlay = function (_a) {
    var isActive = _a.isActive;
    return React.createElement(ImageOverlay, { isActive: isActive });
};
var templateObject_1;
